import React, { createContext, useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { user } = useAuth();
  const [userId, setUserId] = useState(null);
  const [projectId, setProjectId] = useState(null);

  useEffect(() => {
    const syncFromStorage = () => {
      const storedProjectId = localStorage.getItem("projectId");
      if (storedProjectId && user?.userId) {
        setProjectId(storedProjectId);
        setUserId(user.userId);
      }
    };

    syncFromStorage();
    window.addEventListener("projectChanged", syncFromStorage);
    return () => window.removeEventListener("projectChanged", syncFromStorage);
  }, [user]);

  return (
    <UserContext.Provider value={{ userId, projectId }}>
      {children}
    </UserContext.Provider>
  );
};
